const compressWithBase64 = (text: string) => {
	return btoa(text);
};

export default compressWithBase64;
